import * as React from "react";
import { connect } from "react-redux";
import { DetailsList, IColumn, CommandBar, SelectionMode, ISelection, Selection, SearchBox, ICommandBarItemProps
    , CheckboxVisibility } from "office-ui-fabric-react/lib";
import { Dialog } from "office-ui-fabric-react/lib";
import New from "../New";
import * as H from "history";
import { RouteComponentProps } from "react-router";
import { RootState } from "~/state";
import { getTemplatesByType, getProductPageCount } from "~/state/action";
import { getProducts } from "~/state/action";
import { Product, Template, ProductUpdate, ProductFilter } from "typings";
import { createMainProduct, loadProducts, updateMultipleProducts, addToProduct } from "~/state/products/action";
import { parse as queryStringParser } from "query-string";
import TemplateSelectorDialog from "../TemplateSelectorDialog";
import { getListSettings } from "./ListSetting";
import { ListCommandBar, DetailListStyle } from "../products.style";
import Paginate from "./Paginate";
// import TemplateDropdown from "../TemplateDropdown";

export interface Props extends RouteComponentProps<{ productGroup: string }> { }

interface State
{
    showNewProductDialog: boolean;
    parentProductSearch: boolean;
    addToParentMode: boolean;
    selectedItems: Product[];
    showTemplateSelector: boolean;
    filters: ProductFilter;
}

const navigateToProduct = (history: H.History<any>, basePath: string) => (productId: string) =>
{
    history.push(basePath + productId);
};

export class ProductList extends React.Component<Props & StateProps, State> {
    state: State = {
        showNewProductDialog: false,
        parentProductSearch: this.props.match.params.productGroup !== undefined,
        addToParentMode: this.props.match.params.productGroup !== undefined,
        showTemplateSelector: false,
        selectedItems: [],
        filters:
        {
            showMainProducts: true,
            showVariants: this.props.match.params.productGroup === undefined,
            page: 0,
            parentId: this.props.match.params.productGroup,
        },
    };

    private loadProducts = (searchQuery: string) =>
    {
        const filters: ProductFilter = this.state.filters;
        if (searchQuery)
        {
            const { search } = queryStringParser(searchQuery);
            filters.term = search as string;
        }
        this.setFiltersAndLoadProducts(filters);
    }

    componentWillMount()
    {
        this.loadProducts(this.props.location.search);
    }

    async componentWillReceiveProps(nextProps: Props & StateProps)
    {
        if (nextProps.match.params.productGroup !== this.props.match.params.productGroup)
        {
            const filters: ProductFilter = { ...this.state.filters };
            filters.parentId = nextProps.match.params.productGroup;
            this.setFiltersAndLoadProducts(filters);
        }
    }

    private toggleNewProductDialog = () => this.setState({showNewProductDialog: !this.state.showNewProductDialog});

    private toggleAddToProduct = () =>
    {
        this.state.addToParentMode = !this.state.addToParentMode;
        this.state.filters.showVariants = !this.state.addToParentMode;
        this.setState({ addToParentMode: this.state.addToParentMode });
        this.loadProducts(this.props.location.search);
    }

    private addProducts = () =>
    {
        this.props.addToProduct(this.props.match.params.productGroup, this.state.selectedItems);
        this.toggleAddToProduct();
    }

    private removeProducts = () =>
    {
        this.props.addToProduct("", this.state.selectedItems);
        this.setFiltersAndLoadProducts(this.state.filters);
    }

    private creatMainProduct = (name: string, templateId: string) =>
    {
        const nav = navigateToProduct(this.props.history, "/products/edit/");
        this.props.createMainProduct(this.state.selectedItems, name, templateId, nav) ;
    }

    private renderNewProductDialog = () =>
    {
        if (this.state.showNewProductDialog)
        {
            const allowedTemplates = this.state.selectedItems.map(x => x.type);
            const templates: Template[] = Object.keys(this.props.templates)
                .map(key => this.props.templates[key])
                .filter((x: Template) => allowedTemplates.indexOf(x.id) > -1 );
            return <Dialog hidden={false} onDismiss={this.toggleNewProductDialog} >
                <New products={this.props.products} onCancel={this.toggleNewProductDialog} onCreate={this.creatMainProduct} templates={templates} />
            </Dialog>;
        }
        return null;
    }

    private onSelectionChanged = () => this.setState({ selectedItems: (this.selection.getSelection() as any) });
    
    private selection: ISelection = new Selection({ onSelectionChanged: this.onSelectionChanged });

    private search = (searchValue: string) =>
    {
        const searchQuery = `?search=${searchValue}`;
        this.props.history.push(`${this.props.match.url}${searchQuery}`);
        this.loadProducts(searchQuery);
    }

    private toggleTemplateDialog = () => this.setState({ showTemplateSelector: !this.state.showTemplateSelector });
    
    private setTemplate  = (templateId: string) =>
    {
        const ids = this.state.selectedItems.map(x => x.id);
        this.props.updateMultipleProducts(ids, { type: templateId });
        this.toggleTemplateDialog();
    }
    
    toggleShowMainProducts = () =>
        this.setFiltersAndLoadProducts({ ...this.state.filters, showMainProducts: !this.state.filters.showMainProducts })

    toggleShowVariants = () =>
        this.setFiltersAndLoadProducts({ ...this.state.filters, showVariants: !this.state.filters.showVariants })

    setPage = (page: number) => this.setFiltersAndLoadProducts({ ...this.state.filters, page });
    
    setTemplateFilter = (template?: Template) =>
        this.setFiltersAndLoadProducts({ ...this.state.filters, template: template ? template.id : undefined })
    
    setFiltersAndLoadProducts = (filters: ProductFilter) =>
    {
        filters.showVariants = this.state.parentProductSearch ? !this.state.addToParentMode : filters.showVariants;
        this.setState({ filters });
        this.props.loadProducts(filters);
    }

    getItemName = (product: Product | undefined) =>
    {
        if (product && product.data && product.data.itemName)
        {
            const keys = Object.keys(product.data.itemName.value);
            if (keys.length > 0)
            {
                return product.data.itemName.value[keys[0]];
            }
        }
        return "";
    }
    
    render()
    {
        // const { filters } = this.state;
        const commandBarItems:  ICommandBarItemProps[] = [];
        const rightCommandBar: ICommandBarItemProps[] = [
            //{
            //    key: "Templates", name: "Search in", iconProps: { iconName: "Filter" },
            //    onRender: () =>
            //        <TemplateDropdown title={"All Templates"} templates={this.props.templates} onTemplateChange={this.setTemplateFilter} />
            //},
            {
                key: "Search", name: "Search", iconProps: { iconName: "Filter" },
                onRender: () => <SearchBox  placeholder="Search (press enter key to search)"  onSearch={this.search} />
            }
        ];
        if (!this.state.parentProductSearch)
        {
            //rightCommandBar.push({
            //    key: "mainProducts", name: "Main products",
            //    iconProps: { iconName: filters.showMainProducts ? "CheckboxComposite" : "Checkbox" },
            //    checked: filters.showMainProducts,
            //    onClick: this.toggleShowMainProducts
            //},
            //{
            //    key: "variants", name: "Variants",
            //    iconProps: { iconName: filters.showVariants ? "CheckboxComposite" : "Checkbox" },
            //    checked: filters.showVariants,
            //    onClick: this.toggleShowVariants
            //});
        }
        if (this.state.parentProductSearch && this.state.selectedItems.length === 0)
        {
            commandBarItems.push({
                key: "Addproducts", name: !this.state.addToParentMode ? "Find new products" : "Show current variants",
                iconProps: { iconName: "BoxAdditionSolid" },
                onClick: this.toggleAddToProduct,
            });
        }
        if (this.state.selectedItems.length > 0)
        {
            if (!this.state.parentProductSearch)
            {
                commandBarItems.push({
                    key: "Createmainproduct", name: "Create main product",
                    iconProps: { iconName: "BoxAdditionSolid" },
                    onClick: this.toggleNewProductDialog,
                });
            }
            else if (this.state.addToParentMode)
            {
                commandBarItems.push({
                    key: "Addtoproduct", name: "Add to product",
                    iconProps: { iconName: "BoxAdditionSolid" },
                    onClick: this.addProducts,
                });
            }
            else
            {
                commandBarItems.push({
                    key: "Removefromproduct", name: "Remove from product",
                    iconProps: { iconName: "BoxSubtractSolid" },
                    onClick: this.removeProducts,
                });
            }
            const hasTemplate = this.state.selectedItems.find(x => x.type !== undefined);
            if (!this.state.parentProductSearch)
            {
                commandBarItems.push( {
                    key: "settemplate", name: (hasTemplate ? "Change" : "Set") + " template",
                    iconProps: { iconName: "PlugDisconnected" },
                    onClick: this.toggleTemplateDialog,
                });
            }
        }
        const columns: IColumn[] = getListSettings(this.props.products, this.props.templates, this.props.history);
        return (
            <div>
                <ListCommandBar>                    
                    <CommandBar items={commandBarItems} farItems={rightCommandBar} />
                </ListCommandBar>
                {this.state.parentProductSearch && this.props.products && this.props.products.length > 0 ?
                    <h2>{this.getItemName(this.props.products.find(p => p.id === this.props.match.params.productGroup))}</h2> : null
                }
                {this.renderNewProductDialog()}
                <DetailListStyle>
                    <DetailsList
                        items={this.props.products}
                        columns={columns}
                        isHeaderVisible={true}
                        selectionMode={SelectionMode.multiple}
                        selection={this.selection}
                        checkboxVisibility={CheckboxVisibility.always}
                        checkboxCellClassName="checkbox-square"
                    />
                </DetailListStyle>
                <Paginate currentPage={this.state.filters.page} pages={this.props.pages} updatePagination={this.setPage} />
                {this.state.showTemplateSelector ? 
                    <TemplateSelectorDialog 
                        onCancel={this.toggleTemplateDialog} 
                        templates={this.props.templates} 
                        onTemplateSelected={this.setTemplate} 
                    /> 
                : null}
            </div>
        );
    }
}

const mapStateToProps = (state: RootState, ownProps: Props) =>
{
    return {
        templates: getTemplatesByType(state, "product"),
        products: getProducts(state),
        pages: getProductPageCount(state)
    };
};

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    createMainProduct: (children: Product[], name: string, templateId: string, navigateToProduct: (id: string) => void) => 
        dispatch(createMainProduct(children, name, templateId, navigateToProduct)),
    addToProduct: (parentId: string, children: Product[]) => dispatch(addToProduct(parentId, children)),
    loadProducts: (filter: ProductFilter) => dispatch(loadProducts(filter)),
    updateMultipleProducts: (productIds: string[], update: ProductUpdate) => dispatch(updateMultipleProducts(productIds, update))
});
type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
export default connect(mapStateToProps, mapDispatchToProps)(ProductList);


// WEBPACK FOOTER //
// ./src/components/product/productList/index.tsx